import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type RecordDeleteDialogProps = {
  open: boolean;
  loading?: boolean;
  recordName?: string | null;
  onClose: () => void;
  onConfirm: () => void;
};

export default function RecordDeleteDialog({
  open,
  loading = false,
  recordName,
  onClose,
  onConfirm,
}: RecordDeleteDialogProps) {
  return (
    <Dialog open={open} onClose={() => !loading && onClose()}>
      <DialogTitle>Silmek istediğinize emin misiniz?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {recordName ? (
            <>
              <strong>{recordName}</strong> kaydı ve varsa özet kalıcı olarak silinecek. Bu işlem
              geri alınamaz.
            </>
          ) : (
            <>Kayıt ve varsa özet kalıcı olarak silinecek. Bu işlem geri alınamaz.</>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Vazgeç
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          Kaydı Sil
        </Button>
      </DialogActions>
    </Dialog>
  );
}
